import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { CollectionRequestBuilder } from '@web/common';
import { isNil, Nillable } from '@web/utils';
import { SelectItem } from '@web/shared/ui';
import { AdminDictionaryBoxCategoryApiService } from '../api/services/admin-dictionary-box-category-api.service';
import { DictionaryCollectionItemResponse } from '../../shared/api/responses/dictionary-collection-item.response';

@Injectable({
  providedIn: 'root',
})
export class AdminDictionaryBoxCategorySelectItemsProviderService {
  private readonly dictionaryApi = inject(AdminDictionaryBoxCategoryApiService);
  private readonly collectionRequestBuilder = inject(CollectionRequestBuilder);

  /* prettier-ignore */
  public fetchSelectItems<Key extends keyof DictionaryCollectionItemResponse>(key: Key, query: Nillable<string> = null): Observable<SelectItem<DictionaryCollectionItemResponse[Key]>[]> {
    return this.dictionaryApi
      .fetchCollection(
        {
          request: this.collectionRequestBuilder
            .disablePagination()
            .build(),
          skipByLoading: true,
          cacheable: true
        },
      )
      .pipe(
        map((response) =>
          response.items
            .filter(item => {
              if (isNil(query)) {
                return item;
              }

              return item.label.toLowerCase().includes(query);
            })
            .map((item) => new SelectItem(item.label, item[key])),
        ),
        catchError(() => of([])),
      )
  }
}
